/**
 * issue-345: 新しい AI スコアベースの推薦ロジック ABテスト関連地域定義
 * 複数のコンポーネントで共通して使用される地域配列を集中管理
 *
 * ABテスト概要:
 * - Aパターン(70%): 既存の推薦ロジック (関東・愛知・大阪でも既存ロジック使用)
 * - Bパターン(30%): 新しい AI スコアベースの推薦ロジック (関東・愛知・大阪でのみ適用)
 */


// すでに sort_score_v2 が適用されている地域
export const ALREADY_APPLIED_AI_RECOMMEND_PREFECTURES = ['tokyo']
